import { HttpClient } from '@adapters/HttpClient';

export interface ShippingRulePresetRule {
  name: string;
  rules: {
    match_type: 'all' | 'any';
    conditions: Array<{
      field: string;
      operator: string;
      value: string;
    }>;
  };
  actions: Array<{
    action: string;
    value: string;
    courier_service_id?: number;
  }>;
  is_active: boolean;
}

export interface ShippingRulePreset {
  id: number;
  owner_team_id: number;
  name: string;
  description: string | null;
  rules_payload: ShippingRulePresetRule[];
  rules_count: number;
  created_at: string;
  updated_at: string;
}

export interface ShippingRulePresetsResponse {
  data: ShippingRulePreset[];
  meta: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
  };
}

export class ShippingRulePresetsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getShippingRulePresets(
    params: { per_page?: number; page?: number } = {},
  ): Promise<ShippingRulePresetsResponse> {
    const queryParams: Record<string, any> = {};
    if (params.per_page) queryParams.per_page = params.per_page;
    if (params.page) queryParams.page = params.page;
    const response = await this.httpClient.get<ShippingRulePresetsResponse>('/shipping-rule-presets', queryParams);
    return response;
  }
}
